export default function SiteChange(adatok) {
  if (!adatok.logo) return;

  const site = document.querySelector(".currently-playing .kaszi");
  const siteLogo = document.querySelector(".currently-playing .kaszi img");
  const siteDesc = document.querySelector(".currently-playing .kaszi p");

  if (!site || !siteLogo || !siteDesc) return;

  site.classList.remove("active");
  site.classList.add("change");

  setTimeout(() => {
    siteLogo.src = adatok.logo;
    siteDesc.textContent = adatok.desc;
    site.classList.remove("change");
  }, 700);
}
